import { State, Action, StateContext, Selector } from '@ngxs/store';
import { catchError, tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { WelcomeService } from 'src/app/site/feature-modules/welcome/services/welcome.service';
import { ICompanyInfo } from 'src/app/site/feature-modules/welcome/models/welcome.models';
import { GetCompanyInfo } from './company-info.action';


export class CompanyInfoStateModel {
  companyInfo?: ICompanyInfo | null = null;
}

@State<CompanyInfoStateModel>({
  name: 'companyInfo',
  defaults: {
    companyInfo: null,
  },
})

@Injectable()
export class CompanyInfoState {
  constructor(private welcomeService: WelcomeService) { }

  // Selectors
  @Selector()
  static getCompanyInfo(state: CompanyInfoStateModel) {
    return state.companyInfo;
  }

  // Actions
  @Action(GetCompanyInfo)
  getCompanyInfo({ getState, setState }: StateContext<CompanyInfoStateModel>) {
    return this.welcomeService.getCompanyInfo().pipe(
      tap((result) => {
        const state = getState();
        setState({
          ...state,
          companyInfo: result.data,
        });
      }),
      catchError((error) => {
        setState({
          ...getState(),
          companyInfo: null,
        });
        return of(null);
      })
    );
  }
}
